import { create } from "zustand";

/**
 * Tracks Praetor case-document revisions made in the current thread.
 * Populated from `data-praetor-revision-saved` SSE events during streaming and
 * from persisted `save_revision` tool-call parts on cold-reload hydration.
 * Used by the composer documents pill to show a combined list of all thread
 * documents (generated + Praetor revisions).
 */
export type PraetorRevisionEntry = {
  praetorDocumentId: string;
  title?: string;
};

type PraetorRevisionStoreState = {
  /** Keyed by praetorDocumentId for dedup. */
  entries: Record<string, PraetorRevisionEntry>;
  add: (entry: PraetorRevisionEntry) => void;
  /** Clear all entries (thread switch). */
  clear: () => void;
};

export const usePraetorRevisionStore = create<PraetorRevisionStoreState>((set) => ({
  entries: {},
  add: (entry) =>
    set((state) => ({
      entries: { ...state.entries, [entry.praetorDocumentId]: entry },
    })),
  clear: () => set({ entries: {} }),
}));
